import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const breakpoints = {
  xl: { alias: 'xl', level: 4 },
  lg: { alias: 'lg', level: 3 },
  md: { alias: 'md', level: 2 },
  sm: { alias: 'sm', level: 1 },
  xs: { alias: 'xs', level: 0 },
} as const;

export const useScreenSizes = () => {
  const theme = useTheme();

  const upXL = useMediaQuery(theme.breakpoints.up('xl'));
  const upLG = useMediaQuery(theme.breakpoints.up('lg'));
  const upMD = useMediaQuery(theme.breakpoints.up('md'));
  const upSM = useMediaQuery(theme.breakpoints.up('sm'));

  const breakpoint = ((): keyof typeof breakpoints => {
    if (upXL) return 'xl';
    if (upLG) return 'lg';
    if (upMD) return 'md';
    if (upSM) return 'sm';
    return 'xs';
  })();

  const isSmallScreen = breakpoints[breakpoint].level < breakpoints.md.level;
  const isMediumScreen = breakpoint === 'md';
  const isLargeScreen = breakpoint === 'lg';
  const isXLargeScreen = breakpoint === 'xl';

  const mobileSize = breakpoints[breakpoint].level < breakpoints.sm.level;
  const desktopSize = breakpoints[breakpoint].level > breakpoints.sm.level;
  const notDesktopSize = !desktopSize;

  return {
    breakpoint: breakpoints[breakpoint],
    breakpoints,
    desktopSize,
    isLargeScreen,
    isMediumScreen,
    isSmallScreen,
    isXLargeScreen,
    mobileSize,
    notDesktopSize,
  };
};
